<template>
  <div class="fin-work-in-progress">
    <div :style="{ maxWidth: maxWidth, margin: leftAligned ? '' : '0 auto' }" class="coming-soon-wrapper pa-5">
      <v-img v-if="!hideImage" :src="require('@/assets/workInProgress/coming-soon.svg')" contain/>
      <h1 :class="hideImage ? 'mb-3' : 'mt-9 mb-3'">Wir bleiben dran!</h1>
      <p :style="leftAligned ? '' : 'text-align: center'">Wir sind gerade dabei diese Inhalte fertigzustellen.
        Du kannst dich auf tolle Funktionen, Inhalte und vieles mehr freuen.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "finWorkInProgress",
  props: {
    /** the maximum width of the coming soon wrapping div */
    maxWidth: {
      type: String,
      default: '500px'
    },
    /** if the contents should be left aligned, otherwise centered */
    leftAligned: {
      type: Boolean,
      default: false
    },
    /** if the image should be hidden */
    hideImage: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.coming-soon-wrapper div {
  text-align: center;
}

h1 {
  font-family: $body-font-family;
  font-size: 28px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: normal;
  text-align: center;
  color: $fin-color-primary-dark
}
</style>
